<!--
  <ActionDownloadEvidenceOptions
    size='small'
    :unit="QUnit"
    color="primary",
    activator_icon="mdi-download"
  />
-->

<template>
  <GenericDownloadEvidenceOptions
    v-if="show_action"
    :size="size"
    :unit="unit.document_downloads_options"
    :loading="loading"
    :color="color"
    :disabled="disabled"
    @loading_start="loading_start"
    @loading_stop="loading_stop"
    @option_click="handle_evidence"
  >
  </GenericDownloadEvidenceOptions>
  <!-- <ActionDownloadCurrent v-else-if="(unit.current_state_document||{}).value"
    :size="size"
    :unit="unit"
    :loading="loading"
    :color="color"
    activator_icon="mdi-flash"
    @loading_start="loading_start"
    @loading_stop="loading_stop"
  >
  </ActionDownloadCurrent> -->
</template>

<style>
  .fieldfile-icon:after{
    height: unset !important;
  }
</style>

<script>
import { downloadFile } from '@/utils/browserfiles';
import QUnitAPI from '@/api/QUnit';
import QUnit from '@/qunit/QUnit';
import AlertNotification from '@/components/AlertNotification'
import FileIcons from '@/utils/fileicons'
import ResponsiveMenuDialog from '@/components/ResponsiveMenuDialog'
import GenericDownloadEvidenceOptions from '@/components/explorer/GenericDownloadEvidenceOptions'
import ActionDownloadCurrent from './ActionDownloadCurrent.vue';


export default {
  name: "ActionDownloadEvidenceOptions",

  components: {
    AlertNotification,
    ResponsiveMenuDialog,
    GenericDownloadEvidenceOptions,
    ActionDownloadCurrent,
  },

  props: {
    size: { default: 'small' },
    unit: { required: true },
    loading: { type: Boolean, default: false },
    color: {},
    disabled: Boolean
  },

  data(){
    return{
      files: FileIcons,
      isOpen: false,
    }
  }, 
  
  computed: {

    show_action() {
      // return true;
      return (
        (this.unit.document_downloads_options||{}).current_public_version && (this.unit.document_downloads_options.current_public_version.download_options || []).length > 0
        ||
        (this.unit.document_downloads_options||{}).current_state_document && (this.unit.document_downloads_options.current_state_document.download_options || []).length > 0
      );
     
    },

    current_version_ops() {
      return this.unit.current_public_version ? this.unit.current_public_version.download_options : "No option current v";
    },

    current_state_ops() {
      return this.unit.current_state_document ? this.unit.current_state_document.download_options : "No option state W";
    }
  },
  
  methods: {
    async handle_evidence(option) {
      this.$emit('loading_start');
      let title = option.downloable_title || option.title || option.filename;
      this.isOpen = false;

      try {
        const data = await QUnitAPI.getQUnitFile(
          this.unit._protected.centro,
          this.unit.uid,
          option.attribute,
          option.value,
          option.version,
          title,
          option.pmethod
        );
        downloadFile(data, title);
        if (option.version) {
          this.update_qunit_after();
        }
        this.$emit('loading_stop');

      } catch (err) {
        this.$emit('loading_stop');
        // this.loading = false;
        this.$refs.alert.show('' + err);
        console.error(err);
      }
    },

    async update_qunit_after() {
      const updated_data = await QUnitAPI.getQUnit(this.unit._protected.centro, this.unit.uid);
      let new_qunit = new QUnit(updated_data);
      this.$emit('update', new_qunit);
    },

    type_icon(opt) {
      const mimetype = opt.mimetype;
      return mimetype ? this.files[mimetype].icon : 'mdi-download';
    },
    icon_color(opt) {
      const mimetype = opt.mimetype;
      return mimetype ? this.files[mimetype].color : '';
    },
    loading_start(){
      this.$emit('loading_start');
    },
    loading_stop(){
      this.$emit('loading_stop');
    }
  },
};
</script>
